import { AbstractPreparePurchase } from './AbstractPreparePurchase.es.js';

/**
 * A Generic Prepare purchase object for all kind of products.
 * Compatible products so far:
 * - Distribution v2 - Distribution with ALC pricing (Single, Album, Cover Song..)
 *   - eg. Item -> release, Invoice products (Single | Album, Cover Song)
 * - Mastering v3 Pricing (Packs...)
 *  - eg. Item -> pack, Invoice products (pack)
 */
class PreparePurchase extends AbstractPreparePurchase {
    constructor() {
        super(...arguments);
        this.invoicePreview = null;
    }
}
const keysOfPreparePurchase = ["invoicePreview", "token", "hasPaymentMethod", "hasValidBillingAddress"];

export { PreparePurchase, keysOfPreparePurchase };
